export default __webpack_public_path__ + "static/media/wojak.5ee0a857.svg";